"use strict";
(() => {
  /* CODEX_OUTLET_PIP_LOOP_HANDLER_20260626 */
  function parseOutletPipList(button) {
    try {
      const items = JSON.parse(button.dataset.calloutPipList || "[]");
      return Array.isArray(items) ? items.filter((item) => {
        return item?.pip?.src && item?.main?.src && item?.main?.srcset;
      }) : [];
    } catch (error) {
      console.warn("Outlet PIP list parse skipped", error);
      return [];
    }
  }

  function setOutletImage(image, payload) {
    if (!image || !payload?.src) return;
    if (payload.srcset) image.srcset = payload.srcset;
    else image.removeAttribute("srcset");
    image.src = payload.src;
    if (payload.width) image.width = payload.width;
    if (payload.height) image.height = payload.height;
    image.alt = payload.alt || "";
  }

  function handleOutletPipLoop(event) {
    const button = event.target?.closest?.('.outlet button.callout-pip[data-callout-pip="variant"]');
    if (!button) return;

    const card = button.closest(".card-js");
    const mainImage = card?.querySelector(".media > img.active");
    const pipImage = button.querySelector("img");
    const items = parseOutletPipList(button);
    if (!card || !mainImage || !pipImage || items.length < 2) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const currentIndex = Number(button.dataset.calloutPipIndex || "0");
    const safeIndex = Number.isFinite(currentIndex) && currentIndex >= 0 ? currentIndex % items.length : 0;
    const nextIndex = (safeIndex + 1) % items.length;
    setOutletImage(mainImage, items[safeIndex].main);
    setOutletImage(pipImage, items[nextIndex].pip);
    button.dataset.calloutPipIndex = String(nextIndex);
  }

  document.addEventListener("click", handleOutletPipLoop, true);



  const OUTLET_HEAD_SHAPE_ORDER = ["standard_small", "standard", "standard_wide", "wide_fit"];
  const escapeOutletHtml = value => String(value || "").replace(/[&<>"']/g, c => ({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]));
  Alpine.data("outletRebuild", () => ({
    root: null, productsCount: 0, allProducts: [], loading: false, activeFilter: "all", sourceSynced: false, fitI18n: {},
    init() {
      this.root = this.$el;
      this.allProducts = Array.from(this.root.querySelectorAll("li[data-outlet-variant-id]"));
      this.fitI18n = JSON.parse(this.root.querySelector("[data-outlet-fit-i18n]").textContent);
      this.allProducts.forEach(item => this.renderHeadFit(item));
      this.buildRows(); this.applyFilter(); this.syncSourceProducts();
    },
    buildRows() {
      const source = this.root.querySelector(".outlet__items-grid");
      const groups = new Map();
      const fancyId = "8738421375249", gcmId = "10182959497489";
      const basicIds = ["10101131116817", "8741563040017"];
      this.allProducts.forEach(item => {
        const productId = item.dataset.outletProductId;
        const id = productId === gcmId ? fancyId : productId;
        if (!groups.has(id)) groups.set(id, []);
        groups.get(id).push(item);
      });
      // Fancy owns the heading/order; GCM cards follow all regular Fancy cards.
      const fancyItems = groups.get(fancyId);
      if (fancyItems) fancyItems.sort((a,b) => Number(a.dataset.outletProductId === gcmId)-Number(b.dataset.outletProductId === gcmId));
      const root = document.createElement("div"); root.className = "outlet-rebuild__groups";
      [...groups.entries()].sort(([idA,a],[idB,b]) => {
        const basicOrder = (basicIds.indexOf(idA)+1)-(basicIds.indexOf(idB)+1);
        if (basicOrder) return basicOrder;
        const orderA = idA === fancyId && a[0].dataset.outletProductId === gcmId ? 10 : Number(a[0].dataset.outletProductOrder);
        const orderB = idB === fancyId && b[0].dataset.outletProductId === gcmId ? 10 : Number(b[0].dataset.outletProductOrder);
        return orderA-orderB;
      }).forEach(([id,items]) => {
        const group = document.createElement("section"); group.className = "outlet-rebuild__group";
        const heading = document.createElement("h2"); heading.textContent = id === fancyId && items[0].dataset.outletProductId === gcmId ? "Fancy™ Sunglasses" : items[0].dataset.outletProductTitle;
        const row = document.createElement("ul"); row.className = "outlet__items-grid outlet-rebuild__row";
        row.setAttribute("aria-label", heading.textContent);
        items.forEach(item => row.append(item));
        const carousel = document.createElement("div"); carousel.className = "outlet-rebuild__carousel";
        const prev = document.createElement("button"), next = document.createElement("button");
        prev.type = next.type = "button";
        prev.className = "outlet-rebuild__arrow outlet-rebuild__arrow--prev";
        next.className = "outlet-rebuild__arrow outlet-rebuild__arrow--next";
        prev.innerHTML = '<span aria-hidden="true">‹</span>'; next.innerHTML = '<span aria-hidden="true">›</span>';
        prev.setAttribute("aria-label", this.fitI18n.previousSlide || "Previous slide");
        next.setAttribute("aria-label", this.fitI18n.nextSlide || "Next slide");
        const update = () => {
          const mobile = window.matchMedia("(max-width:749px)").matches;
          const visible = items.filter(i=>!i.hidden);
          const max = row.scrollWidth-row.clientWidth;
          prev.hidden = !mobile || max < 4 || row.scrollLeft < 3;
          next.hidden = !mobile || max < 4 || row.scrollLeft >= max-3;
          const media = visible[0]?.querySelector(".card__inner");
          if (media) carousel.style.setProperty("--outlet-image-middle", `${media.getBoundingClientRect().height/2}px`);
        };
        const step = delta => {
          const visible = items.filter(i=>!i.hidden); if (!visible.length) return;
          const origin = row.getBoundingClientRect().left;
          const offsets = visible.map(i=>i.getBoundingClientRect().left-origin+row.scrollLeft);
          let index = 0;
          offsets.forEach((x,n)=>{if(Math.abs(x-row.scrollLeft)<Math.abs(offsets[index]-row.scrollLeft))index=n;});
          const target = Math.max(0,Math.min(visible.length-1,index+delta));
          row.scrollTo({left:offsets[target],behavior:window.matchMedia("(prefers-reduced-motion:reduce)").matches?"auto":"smooth"});
        };
        prev.addEventListener("click",()=>step(-1)); next.addEventListener("click",()=>step(1));
        row.addEventListener("scroll",update,{passive:true});
        new ResizeObserver(update).observe(row);
        carousel.append(row,prev,next); group.append(heading,carousel); root.append(group);
      });
      source.replaceWith(root);
      const align = () => {
        cancelAnimationFrame(this.alignFrame);
        this.alignFrame = requestAnimationFrame(()=>this.alignCards());
      };
      window.addEventListener("resize",align,{passive:true});
      document.fonts?.ready.then(align);
      align();
    },
    alignCards() {
      const root=this.root.querySelector(".outlet-rebuild__groups"); if(!root)return;
      const desktop=window.matchMedia("(min-width:750px)").matches;
      root.style.removeProperty("--outlet-title-height");
      root.style.removeProperty("--outlet-tags-height");
      root.style.removeProperty("--outlet-colors-height");
      if(!desktop)return;
      const visible=this.allProducts.filter(i=>!i.hidden);
      for(const [key,selector] of [["title",".card__static-title"],["tags",".card__tag-wrapper"],["colors",".card__colors-info"]]) {
        const heights=visible.map(i=>i.querySelector(selector)?.getBoundingClientRect().height||0);
        root.style.setProperty(`--outlet-${key}-height`,`${Math.ceil(Math.max(0,...heights))}px`);
      }
    },
    onSelectChange(event) { this.activeFilter = event.target.value; this.applyFilter(); },
    applyFilter() {
      this.productsCount=0;
      this.allProducts.forEach(item=>{item.hidden = item.dataset.sourceMatched === "false" || (this.activeFilter !== "all" && item.dataset.filterOption !== this.activeFilter); if(!item.hidden)this.productsCount++;});
      this.root.querySelectorAll(".outlet-rebuild__group").forEach(group=>{group.hidden=![...group.querySelectorAll("li[data-outlet-variant-id]")].some(item=>!item.hidden);});
      this.alignCards();
    },
    activeHeadShapes(fitLabel) {
      const text = String(fitLabel || "").toLowerCase();
      if (!text) return ["standard_small", "standard", "standard_wide"];
      if (text.includes("flexible")) return [...OUTLET_HEAD_SHAPE_ORDER];
      if (text.includes("smaller") || text.includes("small")) return ["standard_small", "standard"];
      if (text.includes("normal") && text.includes("larger")) return ["standard", "standard_wide", "wide_fit"];
      if (text.includes("larger") || text.includes("large")) return ["standard_wide", "wide_fit"];
      if (text.includes("normal")) return ["standard_small", "standard", "standard_wide"];
      return ["standard_small", "standard", "standard_wide"];
    },

    renderHeadFit(hostItem) {
      if (!hostItem) return;
      const labels = this.fitI18n?.fitOptions || {};
      const activeShapes = new Set(this.activeHeadShapes(hostItem.dataset.outletFitKey));
      const title = this.fitI18n?.fitSystemLabel || "Head fit";
      const activeText = OUTLET_HEAD_SHAPE_ORDER
        .filter((key) => activeShapes.has(key))
        .map((key) => labels[key] || key)
        .join(", ");
      const fitHandle = String(hostItem.dataset.outletFitKey || "").trim().toLowerCase().replace(/\s*-\s*/g, "-");
      const modalId = (this.root.closest("[data-outlet-fit-prefix]")?.dataset.outletFitPrefix || "") + hostItem.dataset.outletProductId;
      const modal = document.getElementById(modalId);
      const holder = document.createElement("div");
      holder.className = "outlet__head-fit";
      holder.setAttribute("aria-label", title + ": " + activeText);
      holder.innerHTML = [
        '<span class="outlet__head-fit-title">' + escapeOutletHtml(title) + '</span>',
        '<span class="outlet__head-fit-options">',
        OUTLET_HEAD_SHAPE_ORDER.map((key) => (
          '<span class="outlet__head-option outlet__head-option--' + key.replace(/_/g, "-") + (activeShapes.has(key) ? " outlet__head-option--active" : "") + '" aria-label="' + escapeOutletHtml(labels[key] || key) + '">' +
            '<span class="outlet__head-icon" aria-hidden="true"></span>' +
            '<span class="outlet__head-label">' + escapeOutletHtml(labels[key] || key) + '</span>' +
          '</span>'
        )).join(""),
        '</span>',
      ].join("");

      if (modal) {
        const options = holder.querySelector(".outlet__head-fit-options");
        const button = document.createElement("button");
        button.type = "button";
        button.className = options.className;
        button.innerHTML = options.innerHTML;
        button.setAttribute("aria-label", title + ": " + activeText);
        button.setAttribute("aria-haspopup", "dialog");
        button.setAttribute("aria-controls", modalId);
        button.addEventListener("click", () => { modal.show(button); });
        options.replaceWith(button);
      }

      const cardInfo = hostItem.querySelector(".card__information--with-label")
        || hostItem.querySelector(".card__information")
        || hostItem;
      const swatches = hostItem.querySelector(".outlet__variant-swatches");
      if (swatches?.parentNode) swatches.insertAdjacentElement("afterend", holder);
      else cardInfo.append(holder);
    },

    async syncSourceProducts() {
      const section = this.root.closest(".outlet");
      if (!section || section.dataset.outletSourceSync !== "true" || !section.dataset.outletSourceUrl) {
        this.sourceSynced = true;
        return;
      }

      this.loading = true;

      try {
        const response = await fetch(section.dataset.outletSourceUrl, { credentials: "same-origin" });
        if (!response.ok) throw new Error("Outlet source request failed: " + response.status);

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, "text/html");
        const sourceIds = new Set(
          Array.from(doc.querySelectorAll(".outlet__items-grid li[data-outlet-variant-id]"))
            .map((item) => item.dataset.outletVariantId)
            .filter(Boolean)
        );

        if (sourceIds.size > 0) {
          this.allProducts.forEach((item) => {
            item.dataset.sourceMatched = sourceIds.has(item.dataset.outletVariantId) ? "true" : "false";
          });
        }
      } catch (error) {
        console.warn("Outlet source sync skipped", error);
      } finally {
        this.sourceSynced = true;
        this.loading = false;
        
        this.applyFilter(true);
      }
    },
  }));
})();
